import { createPinia } from 'pinia'
import App from './App.vue'
import { createMiddleware } from '@caks/shared/middleware/_middleware'
import { createRouterScroller } from 'vue-router-better-scroller';
import { ViteSSG } from 'vite-ssg'
import { Skeletor } from 'vue-skeletor'
import 'vue-skeletor/dist/vue-skeletor.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { routes } from './router'
import { IonicVue } from '@ionic/vue'
import * as Sentry from "@sentry/vue";

export const createApp = ViteSSG(
  // the root component
  App,
  // vue-router options
  { routes },
  // function to have custom setups
  ({ app, router, routes, isClient, initialState }) => {
    // install plugins etc.
    if (isClient) {
    createMiddleware(router)
    const pinia = createPinia()

    Sentry.init({
        app,
        dsn: "https://2ae5dd3747cc77c6773ee686e292a549@o1124528.ingest.us.sentry.io/4508652215468032",
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    app.use(router).use(pinia).use(IonicVue)
        .use(
            createRouterScroller({
                selectors: {

                    window({to, from, type, savedPosition, element}) {
                        return !(to.name === 'HomeFood' || from.name === 'HomeFood');
                    }
                },
            })
        )
    app.component('VueDatePicker', VueDatePicker);
    app.component('skeletor', Skeletor)
    //router.isReady().then(() => app.mount('#app'))
    }
  }
)
